import { render, staticRenderFns } from "./Page_m.vue?vue&type=template&id=2da42b84&scoped=true"
import script from "./Page_m.vue?vue&type=script&lang=js"
export * from "./Page_m.vue?vue&type=script&lang=js"
import style0 from "./Page_m.vue?vue&type=style&index=0&id=2da42b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da42b84",
  null
  
)

export default component.exports